import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import GrafanaWarning from "./Warning";

const GetIframe = ({
  title,
  url,
  panelId,
  variableObject,
  variableKeys,
  width,
  height,
  divId,
  className,
  showOnlyIcon,
  staticVariableObject
}) => {
  const createIframeElement = (container) => {
    const variables = {...variableObject, ...staticVariableObject}
    const shouldAppendIframe = variableKeys?.every(
      (variable) =>
        variables?.hasOwnProperty(variable) &&
        variables[variable] !== null &&
        variables[variable] !== undefined
    );
    let urlWithParams;

    if (shouldAppendIframe) {
      urlWithParams = `${url}${variableKeys
        .map((variable) =>
          variable === "orgId"
            ? `${variable}=${variables[variable]}`
            : ["from", "to", "refresh"].includes(variable)
            ? `&${variable}=${variables[variable]}`
            : `&var-${variable}=${variables[variable]}`
        )
        .join("")}`;

      urlWithParams = `${urlWithParams}&panelId=${panelId}`;

      const iframe = document.createElement("iframe");
      iframe.title = title;
      iframe.src = urlWithParams;
      iframe.width = width;
      iframe.height = height;
      iframe.className = className ? `${className} box-shadow` : "box-shadow";
      iframe.frameBorder = "0";
      iframe.setAttribute("data-testid", "get-iframe");
      container.appendChild(iframe);
    } else {
      const divElement = document.createElement("div");
      divElement.className = "no-iframe flex-center";
      divElement.style.width = width;
      divElement.style.height = `${height}px`;
      divElement.setAttribute("data-testid", "no-get-iframe");

      const root = ReactDOM.createRoot(divElement);
      root.render(<GrafanaWarning width={width} showOnlyIcon={showOnlyIcon} />);

      container?.appendChild(divElement);
    }
  };

  useEffect(() => {
    const container = document.getElementById(divId);
    createIframeElement(container);
    return () => {
      const iframe = container?.querySelector("iframe[data-testid=get-iframe]");
      if (iframe) {
        container?.removeChild(iframe);
      } else {
        const divElement = container?.querySelector(".no-iframe");
        if (divElement) {
          container?.removeChild(divElement);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [divId, variableObject, panelId]);

  return <></>;
};

export default GetIframe;
